var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WebShopContainer',{attrs:{"title":"Mine valg","send-purchase-progress":"SendOnPurchaseSummary"},on:{"next":_vm.next}},[_c('p',{staticClass:"text-center mb-6"},[_vm._v(" Under ser du en oppsummering av valgene du har gjort og hvilke gebyrer og avgifter som tilkommer boligen. ")]),_c('SummaryListItems')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }